import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/Modules.State.ts